import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateWorkflowMutationVariables = Types.Exact<{
  input: Types.CreateWorkflowInput;
}>;

export type CreateWorkflowMutation = {
  __typename?: 'Mutation';
  createWorkflow: {
    __typename?: 'Workflow';
    id: any;
    name: string;
    description?: string | null;
    enabled: boolean;
    version: number;
    createdAt: any;
    updatedAt: any;
  };
};

export const CreateWorkflowDocument = gql`
  mutation CreateWorkflow($input: CreateWorkflowInput!) {
    createWorkflow(input: $input) {
      id
      name
      description
      enabled
      version
      createdAt
      updatedAt
    }
  }
`;
export type CreateWorkflowMutationFn = Apollo.MutationFunction<
  CreateWorkflowMutation,
  CreateWorkflowMutationVariables
>;

/**
 * __useCreateWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowMutation, { data, loading, error }] = useCreateWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkflowMutation,
    CreateWorkflowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWorkflowMutation,
    CreateWorkflowMutationVariables
  >(CreateWorkflowDocument, options);
}
export type CreateWorkflowMutationHookResult = ReturnType<
  typeof useCreateWorkflowMutation
>;
export type CreateWorkflowMutationResult =
  Apollo.MutationResult<CreateWorkflowMutation>;
export type CreateWorkflowMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkflowMutation,
  CreateWorkflowMutationVariables
>;
